import camelCase from "lodash/camelCase";
import upperFirst from "lodash/upperFirst";
import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";

import depPlugin from "@/plugins/depUtil";
import router from "@/route.js";
import VueMask from "v-mask";
import VueAnalytics from "vue-analytics";
import VueLogger from "vuejs-logger";

const isDevelopment = process.env.NODE_ENV === "development";
const loggerOptions = {
  isEnabled: isDevelopment,
  logLevel: "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: false,
  separator: "|",
  showConsoleColors: true,
};
  

Vue.use(VueMask);
Vue.use(depPlugin);
Vue.use(VueRouter);
Vue.use(VueAnalytics, {
  id: "UA-66986500-1",
});
Vue.use(VueLogger, loggerOptions);
const baseComponentsRequireContext = require.context(
  "./components/global",
  true,
  /Base[A-Z]\w+\.(vue|js)$/
);

registerComponents(baseComponentsRequireContext);

global.JQuery = require("jquery");
var $ = global.JQuery;
window.$ = $;

require("select2");
Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");

function registerComponents(requireContext) {
  requireContext.keys().forEach((fileName) => {
    // Get component config
    const componentConfig = requireContext(fileName);

    // Get PascalCase name of component
    const componentName = upperFirst(
      // Strip the leading `'./` and extension from the filename
      camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, "$1"))
    );

    // Register component globally
    Vue.component(componentName, componentConfig.default || componentConfig);
  });
}
